import React, { useState } from 'react';
import { Button, message } from 'antd';
import { connectJiraProject } from './reauthoriseJira';
import styles from './jiraSettings.module.css';
import { config, FeatureList } from './ConnecPromptConfig';

export const ConnectPrompt = ({
  integrationName,
  projectId,
  organizationId,
  type,
  display,
  provider,
  showReconnectMessage = false
}: {
  integrationName: string;
  projectId: string;
  organizationId: string;
  type: string;
  display: string;
  provider: string;
  showReconnectMessage?: boolean;
}) => {
  const [connecting, setConnecting] = useState(false);
  const connectJira = async () => {
    setConnecting(true);
    try {
      await connectJiraProject(organizationId, projectId);
    } catch (error) {
      message.error(
        error.message || 'Could not connect Jira. Please try again.'
      );
    } finally {
      setConnecting(false);
    }
  };
  const configData = config[integrationName];
  const { notifications, reconnectMessage } = configData;
  return (
    <div className={styles.jiraExplanation}>
      {showReconnectMessage && reconnectMessage && reconnectMessage}
      <p>
        Connect BugHerd with your {display} account to{' '}
        {notifications
          ? 'receive notifications'
          : 'sync your tasks and comments'}
      </p>
      <FeatureList
        show={!notifications}
        config={configData}
        display={display}
      />
      {integrationName === 'jira' ? (
        <Button
          type="primary"
          shape="round"
          loading={connecting}
          onClick={connectJira}
        >
          Connect
        </Button>
      ) : (
        <a
          className="btn ant-btn-primary"
          rel="nofollow"
          data-method="post"
          href={`/auth/${provider}?project=${projectId}&organization=${organizationId}&type=${type}`}
        >
          <span className={styles.buttonText}>Connect</span>
        </a>
      )}
    </div>
  );
};
